import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { themes, fonts } from "../themes/themes";
import PendingRequestInterface from "../../infra/aggregates/PendingRequestsInterface";
import "./PendingRequestBox.css";
import { useTranslation } from "react-i18next";
interface PendingRequestsProps {
  requests: PendingRequestInterface[];
}

const UpcomingEventBox = ({ requests }: PendingRequestsProps) => {
  const { i18n, t } = useTranslation();
  return (
    <div>
      {requests.map((req: any, index: number) => {
        return (
          <div key={index}>
            <Grid container className="event-box-pendingBox">
              <Grid item xs={9}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontFamily: fonts.fontFamily,
                        fontSize: fonts.title,
                        color: themes.blackDefault,
                        fontWeight: "bold",
                        textTransform: "capitalize",
                      }}
                    >
                      {req?.event}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontFamily: fonts.fontFamily,
                        fontSize: fonts.subtitle,
                      }}
                    >
                      {req.status == 0 && (
                        <span style={{ color: themes.defaultError }}>
                          {t("Pending")}
                        </span>
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3} style={{ textAlign: "center" }}>
                <Grid container>
                  <Grid item xs={12}>
                    {" "}
                    <Typography
                      style={{
                        fontFamily: fonts.fontFamily,
                        fontSize: fonts.subtitle,
                        color: themes.greyDefault,
                        fontWeight: "bold",
                      }}
                    >
                      {t("Total")}: {req?.total}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        );
      })}
    </div>
  );
};

export default UpcomingEventBox;
